import { css } from '@emotion/react';
import { DesignToken, SpacingToken } from '@livechat/design-system-react-components';

import { MEDIA_MIN_SM } from '_assets/css/breakpoints';

export const activatingContainer = css`
  display: flex;
  flex-direction: column;
  gap: var(${SpacingToken.Spacing3});
  padding: 0 var(${SpacingToken.Spacing5});
  margin-top: 168px;
`;

export const missingAccessContainer = css`
  width: 100%;
  height: calc(100vh - 48px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  color: var(${DesignToken.ContentBasicPrimary});

  ${MEDIA_MIN_SM} {
    height: 100vh;
  }
`;

export const missingAccess = css`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const errorMessageTitle = css`
  margin-bottom: var(${SpacingToken.Spacing7});
  display: block;
`;

export const missingAccessLogin = css`
  margin: var(${SpacingToken.Spacing7}) auto var(${SpacingToken.Spacing5});
`;

export const stopScreenLogoContainer = css`
  overflow: hidden;
  align-items: center;
  justify-content: center;
  width: 16px;
  margin-top: var(${SpacingToken.Spacing2});
  margin-right: 6px;
`;

export const userProductsButtonsContainer = css`
  display: flex;
  flex-direction: column;

  > a {
    margin-bottom: var(${SpacingToken.Spacing3});
  }

  ${MEDIA_MIN_SM} {
    flex-direction: row;
    flex-wrap: wrap;

    > a {
      margin-bottom: 0;
    }
  }
`;

export const orTextContainer = css`
  margin: 28px auto 0;
  width: 100%;
  text-align: center;

  > span {
    position: relative;
    display: block;
    margin-bottom: 28px;
    background-color: var(${DesignToken.Background01});

    ::before {
      content: '';
      position: absolute;
      top: 50%;
      left: 0;
      right: 0;
      border-top: 1px solid var(${DesignToken.BorderBasicSecondary});
    }

    > p {
      position: relative;
      z-index: 1;
      padding: 0 20px;
    }
  }
`;
